export enum EMeasureParentType {
    Zone = 1,
    Process = 2,
    Report = 3,
    Lingette = 4,
    Massif = 5,
    Eau = 6,
    AdductionAir = 7,
    Generic = 8
}
